import styled from "styled-components";
import checkmarkImage from "../assets/checkmark.svg";
import React, { useEffect, useState } from "react";

//region CSS
const Popup = styled.div`
  display: flex;
  flex-direction: column;
  position: ${(props) => (props.relativePosition ? "relative" : "fixed")};
  z-index: 99;
  max-height: 300px;
  overflow: auto;
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0 5px 14px rgba(120, 146, 141, 0.05);
  box-sizing: border-box;
  padding: 17px;
`;
const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #ebedf8;
  width: 100%;
  max-width: 500px;
`;
const Checkbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  border-radius: 2px;
  border-color: #089bab;
  border-style: solid;
  border-width: 1px;
  background-color: #ffffff;
  cursor: pointer;
  outline: none;
  margin-top: 5px;
`;
const SelectedCheckbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  border-radius: 2px;
  border-color: #089bab;
  border-style: solid;
  border-width: 1px;
  background-color: #089bab;
  cursor: pointer;
  outline: none;
  margin-top: 5px;
`;
const Label = styled.p`
  margin: 0 0 0 5px;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 32px;
  color: #121a2d;
`;
//endregion

const FilterPopup = ({
  onLastFilterIndexDeselected,
  left,
  top,
  list,
  onSelect /*, onClear*/,
  relativePosition,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    let tempData = [];
    list.forEach((item, index) => {
      if (!tempData.some((o) => o.description === item.description)) {
        item["columnFiltersIndex"] = index;
        tempData.push(item);
      }
    });
    setData(tempData);
  }, [list]);

  return (
    <Popup
      relativePosition={relativePosition}
      style={relativePosition ? { left: 0, top: 0 } : { left: left, top: top }}
    >
      {/*{list.some(o=>!o.selected) &&*/}
      {/*    <ListItem>*/}
      {/*        <SelectedCheckbox>*/}
      {/*            <img src={checkmarkImage} alt={'checkbox is checked'}/>*/}
      {/*        </SelectedCheckbox>*/}
      {/*        <Label>All</Label>*/}
      {/*    </ListItem>*/}
      {/*}*/}
      {/*{list.some(o=>o.selected) &&*/}
      {/*    <ListItem>*/}
      {/*        <Checkbox onClick={()=>onClear(list[0].index)}/>*/}
      {/*        <Label>All</Label>*/}
      {/*    </ListItem>*/}
      {/*}*/}
      {/* Dynamic content */}
      {data
        .filter((o) => o.description)
        .sort((a, b) => {
          if (a.description > b.description) {
            return -1;
          }
          if (b.description > a.description) {
            return 1;
          }
          return 0;
        })
        .map((item) => {
          if (item.selected) {
            return (
              <ListItem
                key={item.description}
                style={
                  !item.hasOwnProperty("show") || item.show
                    ? { display: "flex" }
                    : { display: "none" }
                }
              >
                <SelectedCheckbox
                  onClick={() => {
                    onLastFilterIndexDeselected &&
                      onLastFilterIndexDeselected(item.index);
                    item.selected = !item.selected;
                    onSelect(item);
                  }}
                >
                  <img src={checkmarkImage} alt={"checkbox is checked"} />
                </SelectedCheckbox>
                <Label>{item.description}</Label>
              </ListItem>
            );
          } else {
            return (
              <ListItem
                key={item.description}
                style={
                  !item.hasOwnProperty("show") || item.show
                    ? { display: "flex" }
                    : { display: "none" }
                }
              >
                <Checkbox
                  onClick={() => {
                    onLastFilterIndexDeselected &&
                      onLastFilterIndexDeselected(-1);
                    item.selected = !item.selected;
                    onSelect(item);
                  }}
                />
                <Label>{item.description}</Label>
              </ListItem>
            );
          }
        })}
    </Popup>
  );
};

export default FilterPopup;
